import React, { forwardRef } from "react";
import { fmtEuro, fmtDate } from "@/lib/format";

const sum = (rows, k) => rows.reduce((s, r) => s + (Number(r[k]) || 0), 0);

export const ReservationsPrint = forwardRef(({ rows, year, search }, ref) => (
  <div style={{ position: "fixed", left: -10000, top: 0, width: 1400 }} aria-hidden="true">
    <div ref={ref} style={{ padding: 24, background: "#fff", color: "#45423C", fontFamily: "sans-serif" }}>
      <h2 style={{ fontSize: 20, margin: 0 }}>TAF Beach Villas Kos — Κρατήσεις</h2>
      <p style={{ fontSize: 12, color: "#6F6A60", margin: "4px 0 12px" }}>
        {year ? `Έτος ${year}` : "Όλα τα έτη"}{search ? ` · Αναζήτηση: «${search}»` : ""} · {rows.length} κρατήσεις · {new Date().toLocaleDateString("el-GR")}
      </p>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
        <thead>
          <tr style={{ background: "#F1EDE6", textAlign: "left" }}>
            {["Κωδ.", "Άφιξη", "Αναχώρηση", "Επισκέπτης", "Κινητό", "Βίλα", "Άτ.", "Κατάσταση", "F&B", "Extras", "Τζίρος", "Πληρωμένα", "Υπόλοιπο"].map((h) => (
              <th key={h} style={{ padding: "6px 6px" }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} style={{ borderTop: "1px solid #E3DED4" }}>
              <td style={{ padding: "4px 6px" }}>{r.code}</td>
              <td style={{ padding: "4px 6px" }}>{fmtDate(r.fromd)}</td>
              <td style={{ padding: "4px 6px" }}>{fmtDate(r.tod)}</td>
              <td style={{ padding: "4px 6px" }}>{r.guest_name}</td>
              <td style={{ padding: "4px 6px" }}>{r.mobile}</td>
              <td style={{ padding: "4px 6px" }}>{r.room}</td>
              <td style={{ padding: "4px 6px" }}>{(r.adults || 0) + (r.children || 0)}</td>
              <td style={{ padding: "4px 6px" }}>{r.status}</td>
              <td style={{ padding: "4px 6px", textAlign: "right" }}>{fmtEuro(r.fb_total)}</td>
              <td style={{ padding: "4px 6px", textAlign: "right" }}>{fmtEuro(r.extras_total)}</td>
              <td style={{ padding: "4px 6px", textAlign: "right", fontWeight: 600 }}>{fmtEuro(r.grand_total)}</td>
              <td style={{ padding: "4px 6px", textAlign: "right" }}>{fmtEuro(r.paid_total)}</td>
              <td style={{ padding: "4px 6px", textAlign: "right" }}>{fmtEuro(r.balance)}</td>
            </tr>
          ))}
          <tr style={{ borderTop: "2px solid #45423C", fontWeight: 700 }}>
            <td style={{ padding: "6px" }} colSpan={8}>ΣΥΝΟΛΟ</td>
            {["fb_total", "extras_total", "grand_total", "paid_total", "balance"].map((k) => (
              <td key={k} style={{ padding: "6px", textAlign: "right" }}>{fmtEuro(sum(rows, k))}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  </div>
));
ReservationsPrint.displayName = "ReservationsPrint";
